module.exports = __webpack_public_path__ + "static/img/2-4.01e5779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-4.jpg
// module id = +xKo
// module chunks = 1